import React from 'react'
import { OverlayTrigger } from 'react-bootstrap'
import { IArbitrationDetail } from 'types/arbitrationTypes'
import { formatDateTime } from 'utils/dateUtils'
import { StyledSaleInfoSection } from './SaleInfoSection.styled'
import { StyledTooltip } from '../ArbitrationForm.styled'

function stripHtmlTags(html: string): string {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent ?? div.innerText ?? ''
}

interface IProps {
  detail: IArbitrationDetail
}

export const SaleInfoSection: React.FC<IProps> = ({ detail }) => {
  const announcements = detail.announcements ?? []
  const plainText = announcements.map(stripHtmlTags).join('; ')

  return (
    <StyledSaleInfoSection>
      <h6>Sale Information</h6>
      <div className="sale-info-grid">
        <div className="info-item">
          <span className="info-label">VIN:</span>
          <span className="info-value">{detail.vin}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Model Year:</span>
          <span className="info-value">{detail.modelYear}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Model:</span>
          <span className="info-value">{detail.model}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Grade:</span>
          <span className="info-value">{detail.grade || '—'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Mileage at Sale:</span>
          <span className="info-value">{detail.saleMileage?.toLocaleString()}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Sale Price:</span>
          <span className="info-value">${detail.salePrice?.toLocaleString()}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Sale Date:</span>
          <span className="info-value">{formatDateTime(detail.saleDate)}</span>
        </div>
        {announcements.length > 0 && (
          <div className="info-item full-width">
            <span className="info-label">Announcements:</span>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <StyledTooltip id="arbitration-announcements-tooltip">
                  {announcements.map((announcement, index) => (
                    <div key={index} dangerouslySetInnerHTML={{ __html: announcement }} />
                  ))}
                </StyledTooltip>
              }
            >
              <span className="info-value announcements-block">{plainText}</span>
            </OverlayTrigger>
          </div>
        )}
      </div>
      <hr />
    </StyledSaleInfoSection>
  )
}
